import { ProcessingOverlay } from '@components'

import { BorderRadius, Color } from '@billy/design-system'
import { ReactElement } from 'react'

import { CompanyContact } from '../../../CompanyContact'
import { useCompanyInformationForm } from '../../contexts/companyInformationFormContext'
import { CompanyAddress } from './elements/CompanyAddress'
import { CompanyDetails } from './elements/CompanyDetails'
import * as Styled from './styles'

export const ModalBody = (): ReactElement => {
  const { isProcessing, isLoading } = useCompanyInformationForm()

  return (
    <Styled.ModalBodyWrapper>
      {(isProcessing || isLoading) && (
        <ProcessingOverlay color={Color.White} borderRadius={BorderRadius.R16} withAnimation />
      )}
      <CompanyDetails />
      <CompanyAddress />
      <CompanyContact />
    </Styled.ModalBodyWrapper>
  )
}
